// removed by extract-text-webpack-plugin
module.exports = {"container":"_3UPDOC5e4w4Ehco2hTZ0ur","userName":"vGNSKlbhBRI5mBt40Nlth","userEmail":"_1D0Mb8HP2z4aT3J4m_7VSW","logout":"ZEOQEPw0epJ1x7CmltHIT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserProfile.css
// module id = 386
// module chunks = 0